module.exports = __webpack_public_path__ + "img/banner_lowAltitude_m.d8cf40a9.jpg";